export default "__VITE_ASSET__CsSaJEuI__"